import React, { useCallback, useEffect, useState } from "react";
import { addNotification as notify } from "reapop";
import Select from "../../forms/Select";
import InputGroup from "../../forms/InputGroup";
import { validateField } from "../../pages/functions";
import { api_v2 } from "../NewIndex.api";
import "./style.css";
import { selectedCountry } from "../../actions/referenceData";
import { value } from "approvejs";

const TETProductRule = (props) => {
  const fieldWithContent = {
    productName: {
      name: "productName",
      rules: { title: props.content.product, required: true },
    },
    tempRange: {
      name: "tempRange",
      rules: { title: props.content.tempRange, required: true },
    },
    tempActual: {
      name: "tempActual",
      value: "",
      rules: {
        title: props.content.degrees,
        required: { message: props.content.tempRequired },
        format: {
          regex: /^(-?\d{1,3})$/,
          message: props.content.tempRequirement,
        },
      },
    },
    tempIndicator:
      props.preferredTemp === "F"
        ? {
            name: "tempIndicator",
            rules: { title: props.content.tempIndicatorF, required: true },
          }
        : {
            name: "tempIndicator",
            rules: { title: props.content.tempIndicatorC, required: true },
          },
    days: {
      name: "days",
      rules: {
        title: props.content.days,
      },
    },
    hours: {
      name: "hours",
      rules: {
        title: props.content.hours,
      },
    },
    minutes: {
      name: "minutes",
      rules: {
        title: props.content.minutes,
      },
    },
  };
  const [fields, setFields] = useState(fieldWithContent);
  const [productDetails, setProductDetails] = useState([]);
  const [productOptions, setProductOptions] = useState([
    { value: "others", label: "All Other Products" },
  ]);
  const [rangeOptions, setRangeOptions] = useState([]);
  const [tempOptions, setTempOptions] = useState([]);
  const [daysOptions, setDaysOptions] = useState([]);
  const [hoursOptions, setHoursOptions] = useState([]);
  const [minutesOptions, setMinutesOptions] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState({});
  const [selectedRule, setSelectedRule] = useState({});
  const [genericMessage, setGenericMessage] = useState("");
  const [disableTempRanges, setDisableTempRanges] = useState(true);
  const [calculetedRule, setCalculatedRule] = useState({});

  useEffect(() => {
    const payload = { country: props.selectedCountry };
    api_v2.fetchUserTETProducts(payload, (res) => {
      if (res.length > 0) {
        setProductDetails(res);

        let productList = [];
        for (let product of res) {
          if (product.showInTETList) {
            productList.push({
              value: product.name,
              label: product.stabilityProductName,
            });
          }
        }
        productList.push({ value: "others", label: "All Other Products" });
        setProductOptions(productList);
      }
    });
    if (props.preferredTemp === "F") {
      setTempOptions([
        { value: "F", label: "°F" },
        { value: "C", label: "°C" },
      ]);
    } else {
      setTempOptions([
        { value: "C", label: "°C" },
        { value: "F", label: "°F" },
      ]);
    }

    let dayOptions = [];
    for (let i = 0; i < 100; i++) {
      let dayLabel = i.toString();
      if (i === 7) {
        dayLabel = i.toString() + " (1 week)";
      } else if (i > 0 && i % 7 === 0) {
        dayLabel = i.toString() + " (" + (i / 7).toString() + " weeks)";
      }

      dayOptions.push({ value: i.toString(), label: dayLabel });
    }
    dayOptions.push({ value: "100", label: "100 or more" });
    setDaysOptions(dayOptions);

    let hourOptions = [];
    for (let i = 0; i < 24; i++) {
      hourOptions.push({ value: i.toString(), label: i.toString() });
    }
    setHoursOptions(hourOptions);

    let minuteOptions = [];
    for (let i = 0; i < 60; i++) {
      minuteOptions.push({ value: i.toString(), label: i.toString() });
    }
    setMinutesOptions(minuteOptions);
  }, [props.selectedCountry, props.preferredTemp]);

  useEffect(() => {
    handleReset();
  }, [props.selectedRole]);

  const validate = (e, field) => {
    const validateFields = validateField(e, field, fields);
    setFields({ ...validateFields });
  };

  const getSelectedProductMessage = (selecedproductDetails, rules) => {
    if (props.preferredTemp === "F") {
      setGenericMessage(
        `The recommended storage for ${
          selecedproductDetails.stabilityProductName
        } is ${converToFahrenheit(
          rules.recMinRange
        )}°F  to ${converToFahrenheit(rules.recMaxRange)}°F (${
          rules.recMinRange
        }°C to ${rules.recMaxRange}°C).`
      );
    } else {
      setGenericMessage(
        `The recommended storage for ${
          selecedproductDetails.stabilityProductName
        } is ${rules.recMinRange}°C to ${
          rules.recMaxRange
        }°C (${converToFahrenheit(
          rules.recMinRange
        )}°F  to ${converToFahrenheit(rules.recMaxRange)}°F).`
      );
    }
  };
  const selectedMinutes = () => {
    // part of check. for conditional Humira messaging
    const days = fields.days.value ? parseInt(fields.days.value, 10) : 0;
    const hours = fields.hours.value ? parseInt(fields.hours.value, 10) : 0;
    const minutes = fields.minutes.value
      ? parseInt(fields.minutes.value, 10)
      : 0;
    const duration = days * 24 + hours + minutes / 60;
    return duration;
  };

  const convertToCelsius = (fahrenheit) => {
    const celsius = Math.round(((fahrenheit - 32) * 5) / 9);
    return celsius;
  };
  const handleCalculate = () => {
    // validate range
    const min =
      fields.tempIndicator.value === "C"
        ? selectedRule.recMinRange
        : converToFahrenheit(selectedRule.recMinRange);
    const max =
      fields.tempIndicator.value === "C"
        ? selectedRule.recMaxRange
        : converToFahrenheit(selectedRule.recMaxRange);
    switch (fields.tempRange.value) {
      case "UNDER":
        if (parseInt(fields.tempActual.value, 10) >= parseInt(min, 10)) {
          setCalculatedRule({ message: props.content.mismatch });
          return false;
        }
        return true;
      case "OVER":
        if (parseInt(fields.tempActual.value, 10) <= parseInt(max, 10)) {
          setCalculatedRule({ message: props.content.mismatch });
          return false;
        }
        return true;
      case "RECOMMENDED":
        if (
          parseInt(fields.tempActual.value, 10) < parseInt(min, 10) ||
          parseInt(fields.tempActual.value, 10) > parseInt(max, 10)
        ) {
          setCalculatedRule({ message: props.content.mismatch });
          return false;
        }
        return true;
      default:
        return true;
    }
  };

  const checkRuleMatch = useCallback(() => {
    if (handleCalculate()) {
      for (let i = 0; i < selectedRule.rule.length; i++) {
        const rule = selectedRule.rule[i];
        const actualTemp = parseInt(fields.tempActual.value);
        const temp =
          fields.tempIndicator.value === "F"
            ? convertToCelsius(actualTemp)
            : actualTemp;
        const hours = selectedMinutes();

        const tempMinCondition =
          (rule.tempMinRange === ">=" && temp >= Number(rule.tempMin)) ||
          (rule.tempMinRange === ">" && temp > Number(rule.tempMin)) ||
          (rule.tempMinRange === "<" && temp < Number(rule.tempMin));

        const tempMaxCondition =
          rule.tempMaxRange && rule.tempMax
            ? (rule.tempMaxRange === "<=" &&
                (!rule.tempMax || temp <= Number(rule.tempMax))) ||
              (rule.tempMaxRange === "<" && temp < Number(rule.tempMax))
            : true;

        const durationMinCondition =
          rule.durationMinRange && rule.durationMin
            ? (rule.durationMinRange === "<=" &&
                hours <= Number(rule.durationMin)) ||
              (rule.durationMinRange === ">" &&
                hours > Number(rule.durationMin))
            : true;

        const durationMaxCondition =
          rule.durationMaxRange && rule.durationMax
            ? rule.durationMaxRange === "<=" &&
              hours <= Number(rule.durationMax)
            : true;

        if (
          tempMinCondition &&
          tempMaxCondition &&
          durationMinCondition &&
          durationMaxCondition
        ) {
          setCalculatedRule(rule);
          
          if (typeof ABVMetrics !== 'undefined') {
          const formmd = {
            frmType: 'stability tool',
            frmStage: 'final-complete',
            formattr: {
              role: props.userType,
              product: selectedProduct.productCode,
              temp_range: fields.tempRange.value,
              temp: `${fields.tempActual.value}° ${fields.tempIndicator.value}`,
              duration: `${fields.days.value},${fields.hours.value},${fields.minutes.value}`
            },
            formOutput: rule.message
          }

          ABVMetrics.sendFormAnalytics(formmd) // eslint-disable-line no-undef
        }

          return true;
        }
      }
    }
  }, [fields, selectedRule]);

  const handleSelectedProduct = useCallback(
    (e) => {
      setCalculatedRule({});
      setSelectedRule({});
      setGenericMessage("");
      fields.tempRange.value = "";
      fields.tempActual.value = "";
      fields.tempIndicator.value = "";
      fields.days.value = "";
      fields.hours.value = "";
      fields.minutes.value = "";
      if (e === "others") {
        setDisableTempRanges(true);
        setGenericMessage(props.contactInfo);
      } else {
        const selecedproductDetails = productDetails.find(
          (product) => product.name === e
        );
        setSelectedProduct(selecedproductDetails);
        if (selecedproductDetails.showGenericMessage) {
          setDisableTempRanges(true);
          setGenericMessage(props.contactInfo);
        } else {
          const payload = {
            countryName: props.selectedCountry,
            productCode: selecedproductDetails.productCode,
            language: props.selectedLanguage,
            userType:
              props.userType === "PATIENT"
                ? "Patient / Healthcare Provider on behalf of a specific Patient"
                : props.selectedRole,
          };
          api_v2.fetchUserTETRule(payload, (res) => {
            if (res.rules) {
              const rulesJSON = JSON.parse(res.rules);
              if (rulesJSON.showGenericMessage === "true") {
                setDisableTempRanges(true);
                setGenericMessage(rulesJSON.genericMessage);
              } else {
                handleTempRranges(rulesJSON);
                setSelectedRule(rulesJSON);
                setDisableTempRanges(false);
                getSelectedProductMessage(selecedproductDetails, rulesJSON);
              }
            } else {
              setGenericMessage(props.contactInfo);
            }
          });
        }
      }
    },
    [productOptions, props.selectedCountry, props.selectedRole]
  );
  const converToFahrenheit = (celsius) => {
    const fahrenheit = Math.round((celsius * 9) / 5 + 32);
    return fahrenheit;
  };
  const handleTempRranges = (res) => {
    const ranges = [];
    if (props.preferredTemp === "F") {
      ranges.push({
        value: "UNDER",
        label: `${props.content.below} ${converToFahrenheit(
          res.recMinRange
        )} °F (${res.recMinRange} °C)`,
      });
      ranges.push({
        value: "RECOMMENDED",
        label: `${props.content.within} ${converToFahrenheit(
          res.recMinRange
        )} ${props.content.to} ${converToFahrenheit(res.recMaxRange)} °F (${
          res.recMinRange
        } to ${res.recMaxRange} °C)`,
      });
      ranges.push({
        value: "OVER",
        label: `${props.content.above} ${converToFahrenheit(
          res.recMaxRange
        )} °F (${res.recMaxRange} °C)`,
      });
    } else {
      ranges.push({
        value: "UNDER",
        label: `${props.content.below} ${
          res.recMinRange
        } °C (${converToFahrenheit(res.recMinRange)} °F)`,
      });
      ranges.push({
        value: "RECOMMENDED",
        label: `${props.content.within} ${res.recMinRange} ${
          props.content.to
        } ${res.recMaxRange} °C (${converToFahrenheit(
          res.recMinRange
        )} to ${converToFahrenheit(res.recMaxRange)} °F)`,
      });
      ranges.push({
        value: "OVER",
        label: `${props.content.above} ${
          res.recMaxRange
        } °C (${converToFahrenheit(res.recMaxRange)} °F)`,
      });
    }
    ranges.push({
      value: "BOTH_UNDER_OVER",
      label: props.content.both,
    });
    setRangeOptions({ ranges });
  };

  const isCalculateFieldEnabled = useCallback(() => {
    return (
      fields.productName.value &&
      fields.tempRange.value &&
      fields.tempActual.value &&
      (!fields.tempActual.errors || fields.tempActual.errors.length === 0) &&
      fields.tempIndicator.value &&
      (fields.days.value || fields.hours.value || fields.minutes.value) &&
      fields.tempRange.value !== "BOTH_UNDER_OVER"
    );
  }, [fields]);

  const handleSelectedTempRange = useCallback(
    (e) => {
      if (e === "BOTH_UNDER_OVER") {
        setCalculatedRule({
          color: "#FA5B5B",
          message: selectedRule.aboveAndBelowMessage,
        });
      }
    },
    [selectedRule]
  );

  const handleReset = () => {
    setSelectedProduct({});
    setSelectedRule({});
    setGenericMessage("");
    setCalculatedRule({});
    fields.productName.value = "";
    fields.tempRange.value = "";
    fields.tempActual.value = "";
    fields.tempIndicator.value = "";
    fields.days.value = "";
    fields.hours.value = "";
    fields.minutes.value = "";
  };

  return (
    <div className="row TET_Rule_Form">
      <div className="col-md-6">
        <div>
          <p className="TET_Question_Header mt-0">
            {props.content.productName}
          </p>
          <Select
            searchable
            clearable={false}
            options={productOptions}
            field={fields.productName}
            deleteRemoves={false}
            backspaceRemoves={false}
            validate={(e) => validate(e, fields.productName)}
            onChange={(e) => handleSelectedProduct(e)}
          />
        </div>
        {!disableTempRanges && (
          <div>
            {fields.productName.value && (
              <div>
                <p className="TET_Question_Header">
                  {props.content.tempQuestion}
                </p>
                <Select
                  searchable
                  clearable={false}
                  options={rangeOptions.ranges}
                  field={fields.tempRange}
                  deleteRemoves={false}
                  backspaceRemoves={false}
                  validate={(e) => validate(e, fields.tempRange)}
                  onChange={(e) => handleSelectedTempRange(e)}
                />
              </div>
            )}
            {fields.tempRange.value &&
              fields.tempRange.value !== "BOTH_UNDER_OVER" && (
                <div>
                  <p className="TET_Question_Header">
                    {props.content.temperature}
                  </p>
                  <div className="row">
                    <div className="col-md-5" key="tempActual">
                      <InputGroup
                        type="number"
                        field={fields.tempActual}
                        validate={(e) => validate(e, fields.tempActual)}
                        onChange={() => {}}
                      />
                    </div>
                    <div className="col-md-3" key="tempIndicator">
                      <Select
                        searchable
                        clearable={false}
                        disabled={false}
                        options={tempOptions}
                        field={fields.tempIndicator}
                        deleteRemoves={false}
                        backspaceRemoves={false}
                        validate={(e) => validate(e, fields.tempIndicator)}
                        onChange={() => {}}
                      />
                    </div>
                  </div>
                </div>
              )}
            {fields.tempActual.value &&
              fields.tempIndicator.value &&
              fields.tempRange.value !== "BOTH_UNDER_OVER" && (
                <div>
                  <p className="TET_Question_Header">
                    {props.content.durationQuestion}
                  </p>
                  <div className="row">
                    <div className="col-md-4">
                      <Select
                        searchable
                        clearable={false}
                        disabled={false}
                        options={daysOptions}
                        field={fields.days}
                        deleteRemoves={false}
                        backspaceRemoves={false}
                        validate={(e) => validate(e, fields.days)}
                        onChange={() => {}}
                      />
                    </div>
                    <div className="col-md-4">
                      <Select
                        searchable
                        clearable={false}
                        disabled={false}
                        options={hoursOptions}
                        field={fields.hours}
                        deleteRemoves={false}
                        backspaceRemoves={false}
                        validate={(e) => validate(e, fields.hours)}
                        onChange={() => {}}
                      />
                    </div>
                    <div className="col-md-4">
                      <Select
                        searchable
                        clearable={false}
                        disabled={false}
                        options={minutesOptions}
                        field={fields.minutes}
                        deleteRemoves={false}
                        backspaceRemoves={false}
                        validate={(e) => validate(e, fields.minutes)}
                        onChange={() => {}}
                      />
                    </div>
                  </div>
                </div>
              )}
          </div>
        )}
        <div className="row mt-4 submit-reset-panel">
          <button
            className={`btn ${
              isCalculateFieldEnabled() ? "btn-info" : "btn-info-no-hover"
            } btn-lg-wide submit-button btn-icon btn-rounded m-r-10`}
            disabled={!isCalculateFieldEnabled()}
            onClick={checkRuleMatch}
            style={{}}
          >
            {props.content.calculate}
          </button>
          <button
            type="button"
            onClick={handleReset}
            className="btn btn-primary btn-outline hover btn-lg btn-icon reset-button btn-rounded"
          >
            <span>{props.content.reset}</span>
          </button>
        </div>
      </div>
      <div className="col-md-6">
        {genericMessage && (
          <div className="stability-rec">
            <table style={{ margin: "1rem" }}>
              <tbody>
                <tr>
                  <td>
                    <span
                      style={{
                        color: "#51C0EF",
                        fontSize: "28px",
                        padding: "0px 10px 0px 0px",
                      }}
                      className="fa fa-info-circle"
                    />
                  </td>
                  <td>
                    <b dangerouslySetInnerHTML={{ __html: genericMessage }}></b>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
        {Object.keys(calculetedRule).length > 0 && (
          <div className="mt-3">
            <div
              className={
                calculetedRule.color === "#58DE49"
                  ? "stability-good-style"
                  : "stability-error-style"
              }
            >
              <table style={{ margin: "1rem" }}>
                <tbody>
                  <tr>
                    <td>
                      <span
                        style={
                          calculetedRule.color === "#58DE49"
                            ? {
                                color: "#18d31f",
                                fontSize: "28px",
                                padding: "0px 10px 0px 0px",
                              }
                            : {
                                color: "red",
                                fontSize: "28px",
                                padding: "0px 10px 0px 0px",
                              }
                        }
                        className={
                          calculetedRule.color === "#58DE49"
                            ? "fa fa-check-circle"
                            : "fa fa-times-circle"
                        }
                      />
                    </td>
                    <td>
                      <b>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: calculetedRule.message
                              .split("\n\n")
                              .join("<br><br>"),
                          }}
                        ></p>
                      </b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TETProductRule;



// WEBPACK FOOTER //
// ./src/mi-app/stabilityTool/V2_TET_Product_Rule.js